module.exports = __webpack_public_path__ + "img/klarna.9f5c4eac.svg";